<template>
  <div class="gw-box shadow">
		<div class="gw-box-header center">
			<h4>About</h4>
		</div>
		<div class="gw-box-body">
			<!-- <div class="gw-row center-v">
				<p v-html="bothText"></p>
				<img src="../assets/christmas.jpg">
			</div> -->
			<div class="gw-column">
				<!-- <img src="../assets/wedding.jpg"> -->
				<!-- <div class="gw-column"> -->
					<p v-html="block1"></p>
					<p v-html="block2"></p>
					<!-- <p v-html="fluteText"></p> -->
				<!-- </div> -->
			</div>
			<div class="pad-lg"></div>
			<div class="gw-row center-h">
				<span v-html="lessonsText"></span>
			</div>
			<div class="pad-lg"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'About',
	
  data () {
    return {
			/**
			 * @gui-admin
			 * list
			 * 
			 * @gui-admin-params
			 * text: string
			 */
			block1: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Aim&eacute;e Raechel, a magna cum laude graduate and Linehan Artist Scholar of University of Maryland Baltimore County (UMBC), provides soft, beautiful music on the harp for many types of events, from weddings to memorials services and open houses to luncheons. Since 2002 when she first fell in love with this elegant instrument, Aim&eacute;e has studied with Jacqueline Pollauf, Eric Sabatino (US Air Force Band Harpist), Rebecca Anstine Smith, Meredith Mancini, and Mary Fitzgerald (US Navy Band Harpist). Through masterclasses, seminars, and other events, she has worked with famous harpists including Alice Chalifoux, Judy Loman, Frank Voltz, and Sylvia Woods. In addition to performing for various paid events, presentations at local schools, recitals, and other concerts, Aim&eacute;e enjoyed playing in many orchestras including UMBC, Londontowne, Anne Arundel Community College, various youth orchestras and pit orchestras for operas and musicals. Although she now spends much of her time teaching, Aim&eacute;e Raechel is still available for any sort of occasion where you can imagine a harp!',
			block2: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;How do you say your name? First, "Aim&eacute;e" is French and it sounds like the beginning of the word "Amazing": <b>ah-MAY</b>. Second, although "Raechel" looks like the common name "Rachel", it is said: <b>ray-SHELL</b>.'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
	padding: 12px;
}

img {
	margin: 12px;
	border: solid black 2px;
	max-height: 400px;
}

@media only screen and (max-width: 800px) and (min-width: 401px) {
	img {
		height: auto;
		width: 400px;
	}
	
	.gw-row {
		flex-direction: column;
	}
}

@media only screen and (max-width: 500px) {
	img {
		height: auto;
		width: 160px;
		margin: 3px;
	}
	
	p {
		padding: 3px;
	}
	
	.gw-row {
		flex-direction: column;
	}
}
</style>
